import type {SystemStyleObject} from '@tempo/core';

export type TypographyOverride = 'display.l' | 'display.s' | 'body.2xl';

export const typographyOverrides = {
	'display.l': {
		fontFamily: 'heading',
		fontSize: '80px',
		fontWeight: 700,
		lineHeight: '80px',
		fontStretch: 'normal',
	},

	'display.s': {
		fontFamily: 'heading',
		fontSize: '48px',
		fontWeight: 700,
		lineHeight: '48px',
		fontStretch: 'normal',
	},

	'body.2xl': {
		fontFamily: 'body',
		fontSize: '32px',
		fontWeight: 900,
		lineHeight: '40px',
		fontStretch: 'normal',
	},
} as const satisfies Record<TypographyOverride, SystemStyleObject>;
